import React, { ReactElement } from 'react';

import KitSnackItem from './KitSnackItem';

interface RenderProps {
  animationsEnabled?: boolean;
  autoHide?: boolean;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  message: string;
  duration: number;
  marginBottom?: number;
}

export default function KitSnackRender({
  animationsEnabled = true,
  autoHide = true,
  visible = false,
  setVisible,
  message,
  duration,
  marginBottom,
}: RenderProps): ReactElement | null {
  const onHide = () => {
    setVisible(false);
  };

  return visible ? (
    <KitSnackItem
      animationsEnabled={animationsEnabled}
      autoHide={autoHide}
      message={message}
      duration={duration}
      onHide={onHide}
      marginBottom={marginBottom}
    />
  ) : null;
}
